import request from '@/utils/request'

export function paperBasicData(data) {
  // 基础数据
  return request({
    url: '/paper/books',
    method: 'get',
    params: data,
  })
}

export function paperChapterData(data) {
  // 章节树形列表
  return request({
    url: '/paper/chapters',
    method: 'get',
    params: data,
  })
}

export function paperKnowledgesData(data) {
  // 知识点树形列表
  return request({
    url: '/paper/knowledges',
    method: 'get',
    params: data,
  })
}

export function questionOptions(data) {
  // 试题类型列表
  return request({
    url: '/question/options',
    method: 'get',
    params: data,
  })
}

export function questionList(data) {
  // 试题列表
  return request({
    url: '/questions',
    method: 'post',
    data: data,
  })
}

export function paperAnswer(data) {
  // 获取试题答案
  return request({
    url: '/questions/answers',
    method: 'get',
    params: data,
  })
}

export function questionCollect(data) {
  // 试题收藏
  return request({
    url: '/question/collections',
    method: 'post',
    data: data,
  })
}

export function addPaperBaskets(data) {
  // 加入试题篮
  return request({
    url: '/paper/baskets',
    method: 'post',
    data: data,
  })
}

export function shoppingCartList(data) {
  // 试题篮列表
  return request({
    url: '/paper/baskets',
    method: 'get',
    params: data,
  })
}

export function removePaperExercise(data) {
  // 删除试题篮试题和移出试题篮
  return request({
    url: '/paper/baskets',
    method: 'delete',
    params: data,
  })
}

export function questionSearchOptions(data) {
  // 获取试题搜索页基础选项
  return request({
    url: '/question/search/options',
    method: 'get',
    params: data,
  })
}

export function questionSearch(data) {
  // 获取试题搜索列表
  return request({
    url: '/question/searches',
    method: 'get',
    params: data,
  })
}

export function wxQrCode() {
  // 获取试题搜索列表
  return request({
    url: '/wechat/qrcode',
    method: 'get',
  })
}

export function wxQrCodeChecking(key) {
  // 获取试题搜索列表
  return request({
    url: `/wechat/check/login?key=${key}`,
    method: 'get',
  })
}
